export const app = {
  state: 'train',
  startGame: 'true',
  currentContainer: 0,
  currentCount: 0,
  numbOfSound: 0,
  isWordTrue: false,
  wrongAnswers: 0,
  randomSounds: [],
  sortStat: false,
};
